export default __webpack_public_path__ + "static/media/ISSO CLASS-9 EXAM PATTERN 2026-27.08297e53.pdf";